import styled from "styled-components";
import { useEffect, useState } from "react";
import { usePage } from "@inertiajs/react";

// Reads the shared `flash` prop (set by FrontdeskV2::ApplicationController#inertia_share) and shows a
// top-right toast after a rack quick-action redirect. Auto-dismisses after 5s.
const Wrap = styled.div`
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 1200;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const Item = styled.div`
  min-width: 260px;
  max-width: 400px;
  padding: 0.7rem 0.9rem;
  border-radius: 10px;
  color: #ffffff;
  font-size: 0.85rem;
  line-height: 1.4;
  box-shadow: 0 12px 30px -10px rgba(0, 0, 0, 0.35);
  background: ${(props) => (props.$kind === "alert" ? "#b91c1c" : "#15803d")};
`;

const Toast = (props) => {
  const page = usePage();
  const flash = page.props.flash || {};
  const signature = `${flash.notice || ""}|${flash.alert || ""}`;
  const [dismissed, setDismissed] = useState("");

  useEffect(() => {
    if (!flash.notice && !flash.alert) {
      return undefined;
    }
    const timer = setTimeout(() => setDismissed(signature), 5000);
    return () => clearTimeout(timer);
  }, [signature, flash.notice, flash.alert]);

  if (dismissed === signature) {
    return null;
  }

  const items = [];
  if (flash.notice) {
    items.push({ id: "notice", kind: "notice", text: flash.notice });
  }
  if (flash.alert) {
    items.push({ id: "alert", kind: "alert", text: flash.alert });
  }
  if (items.length === 0) {
    return null;
  }

  return (
    <Wrap>
      {items.map((item) => (
        <Item key={item.id} $kind={item.kind}>
          {item.text}
        </Item>
      ))}
    </Wrap>
  );
};

export default Toast;
